import { create } from 'zustand';

type Theme = 'light' | 'dark' | 'system';

interface AppState {
  theme: Theme;
  apiConnected: boolean;
  isLoading: boolean;

  // Actions
  setTheme: (theme: Theme) => void;
  setApiConnected: (connected: boolean) => void;
  setIsLoading: (loading: boolean) => void;
}

export const useAppStore = create<AppState>((set) => ({
  theme: 'light',
  apiConnected: false,
  isLoading: false,

  setTheme: (theme) => set({ theme }),
  setApiConnected: (apiConnected) => set({ apiConnected }),
  setIsLoading: (isLoading) => set({ isLoading }),
}));
